



import IMapProperty from './private/IMapProperty';


const MAPPINGS: Array<IMapProperty> = [
/* id property does not exist on https://api.ats-workspace.com/$metadata/SiteObjectOnFloorPlanDto,
   the primary key is a combination here of the #floorplanId & the #siteObjectId,
   mimic this behaviour */
{
    'localName' : 'id',
    'externalName' : 'id',
    'defaultValue' : 0,
    customImport : function(source: Object): any {
        const siteObjectId: number = source.hasOwnProperty('siteObjectId') ? (source as any)['siteObjectId'] : 0;
        const floorPlanId: number = source.hasOwnProperty('siteObjectId') ? (source as any)['siteObjectId'] : 0;
        const id = (floorPlanId << 4) & (siteObjectId);
    },
    removeValueOnExport: true,
},
{
    'localName' : 'siteObjectId',
    'externalName' : 'siteObjectId',
    'defaultValue' : 0,
},
{
    'localName' : 'floorPlanId',
    'externalName' : 'floorPlanId',
    'defaultValue' : 0,
},
{
    'localName' : 'x',
    'externalName' : 'x',
    'defaultValue' : 0,
},
{
    'localName' : 'y',
    'externalName' : 'y',
    'defaultValue' : 0,
},
{
    'localName' : 'pinTypeId',
    'externalName' : 'pinTypeId',
    'defaultValue' : 0,
},
{
    'localName' : 'pinColor',
    'externalName' : 'pinColor',
    'defaultValue' : '',
},
{
    'localName' : 'siteObjectName',
    'externalName' : 'siteObjectName',
    'defaultValue' : '',
},
];

export default MAPPINGS;

